import { Box } from '@superdispatch/ui-lab';
import { Stack } from '@superdispatch/ui';
import { Link, Typography } from '@material-ui/core';
import { useCustomerSupport } from 'shared/helpers/CustomerSupport';
import { isWebView } from 'shared/constants/AppTypeConstants';

export function RatingRestricted() {
  const { showLauncherMessanger } = useCustomerSupport();
  return (
    <Box padding="small" borderRadius="small" backgroundColor="Silver200">
      <Stack>
        <Typography>
          Payment disputes are between shippers and carriers. <br />
          You can only rate shipper you&apos;ve worked with recently. Since you
          don&apos;t have recent orders with this shipper, please reach out to
          them directly about any payment disputes.
        </Typography>
        {!isWebView && (
          <Link
            component="button"
            color="primary"
            onClick={() => {
              showLauncherMessanger();
            }}
          >
            Contact Support
          </Link>
        )}
      </Stack>
    </Box>
  );
}
